import ImageReducer from './image.reducer'
import SettingsReducer from './settings.reducer'
import CropperReducer from './cropper.reducer'
import CanvasReducer from './canvas.reducer'
import LoaderReducer from './loader.reducer'
import ResizeReducer from './resize.reducer'

export default {
  imageStore: ImageReducer,
  settingsStore: SettingsReducer,
  loaderStore: LoaderReducer,
  cropperStore: CropperReducer,
  canvasStore: CanvasReducer,
  resizeStore: ResizeReducer,
}
